import { Component, Input, OnInit } from '@angular/core';
import { LoadingController, ModalController, ToastController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { first } from 'rxjs/operators';
import moment from 'moment';
import _ from 'lodash';

import { endpoints } from 'src/app/constant/endpoints';
import { ApiService } from 'src/app/provider/api.service';
import { ConfigService } from 'src/app/provider/config.service';
import { Events } from 'src/app/provider/events.service';
import { AuthService } from 'src/app/services/auth.service';
import { Subscription } from 'rxjs';
import { ChangeDetectorRef, NgZone } from '@angular/core';
import { NavController } from '@ionic/angular';

import { RouterStateTrackerService } from 'src/app/services/router-state-tracker.service';
import { ThemeService } from 'src/app/services/theme.service';
import { ItemReorderEventDetail } from '@ionic/core';
import { PreferencesService } from 'src/app/services/preferences.service';

@Component({
  selector: 'meal-preference',
  templateUrl: './meal-preference.page.html',
  styleUrls: ['./meal-preference.page.scss'],
  standalone: false,
})
export class MealPreferencePage {
  today = moment().format('YYYY-MM-DD');
  local = 'en-US';
  dateType: string = null;

  loader: boolean = true;
  settings: any = {};
  storeData: any = {};
  customer: any;
  consultantsList: any = [];
  scheduledConsultation: any = [];
  scheduledConsultationNew: any = [
    {
      status: 'accepted',
      consultant: {
        name: 'Rice',
        description: 'A long-grain variety, perfect for various cuisines.',
        picture: '../../assets/fakeitem.jpg',
      },
      notes: 'Premium quality from Vietnam.',
      date: '2025-08-10T00:00:00Z',
      time_slot: '09:00 AM',
    },
    {
      status: 'pending',
      consultant: {
        name: 'Wheat',
        description: 'Hard red winter wheat, ideal for baking bread.',
        picture: '../../assets/fakeitem.jpg',
      },
      notes: 'Sourced from local farms.',
      date: '2025-08-11T00:00:00Z',
      time_slot: '10:30 AM',
    },
    {
      status: 'accepted',
      consultant: {
        name: 'Quinoa',
        description: 'Organic quinoa, a complete protein source.',
        picture: '../../assets/fakeitem.jpg',
      },
      notes: null,
      date: '2025-08-12T00:00:00Z',
      time_slot: '02:00 PM',
    },
    {
      status: 'completed',
      consultant: {
        name: 'Lentils',
        description: 'Brown lentils, great for soups and stews.',
        picture: '../../assets/fakeitem.jpg',
      },
      notes: 'High in fiber.',
      date: '2025-08-13T00:00:00Z',
      time_slot: '09:30 AM',
    },
    {
      status: 'accepted',
      consultant: {
        name: 'Oats',
        description: 'Rolled oats for oatmeal and granola.',
        picture: '../../assets/fakeitem.jpg',
      },
      notes: null,
      date: '2025-08-14T00:00:00Z',
      time_slot: '08:00 AM',
    },
    {
      status: 'completed',
      consultant: {
        name: 'Saffron',
        description: 'Premium quality saffron threads.',
        picture: '../../assets/fakeitem.jpg',
      },
      notes: 'Limited stock. Handle with care.',
      date: '2025-08-15T00:00:00Z',
      time_slot: '11:00 AM',
    },
    {
      status: 'accepted',
      consultant: {
        name: 'Coffee Beans',
        description: 'Arabica coffee beans, medium roast.',
        picture: '../../assets/fakeitem.jpg',
      },
      notes: 'Freshly roasted this week.',
      date: '2025-08-16T00:00:00Z',
      time_slot: '03:00 PM',
    },
    {
      status: 'accepted',
      consultant: {
        name: 'Black Truffle',
        description: 'Whole black truffle, imported from Italy.',
        picture: '../../assets/fakeitem.jpg',
      },
      notes: 'Extremely delicate. Refrigerate immediately.',
      date: '2025-08-17T00:00:00Z',
      time_slot: '04:30 PM',
    },
    {
      status: 'accepted',
      consultant: {
        name: 'Sugar',
        description: 'Granulated white sugar.',
        picture: '../../assets/fakeitem.jpg',
      },
      notes: null,
      date: '2025-08-18T00:00:00Z',
      time_slot: '10:00 AM',
    },
    {
      status: 'accepted',
      consultant: {
        name: 'Salt',
        description: 'Himalayan pink salt.',
        picture: '../../assets/fakeitem.jpg',
      },
      notes: 'Coarse grain.',
      date: '2025-08-19T00:00:00Z',
      time_slot: '01:00 PM',
    },
    {
      status: 'accepted',
      consultant: {
        name: 'Vanilla Beans',
        description: 'Madagascar bourbon vanilla beans.',
        picture: '../../assets/fakeitem.jpg',
      },
      notes: 'Fragrant and oily.',
      date: '2025-08-20T00:00:00Z',
      time_slot: '02:00 PM',
    },
  ];
  pastConsultation: any = [];
  animClassTop: string = 'enterTop';
  animClassBottom: string = 'enterBottom';
  animClassAppear: string = 'enterAppear';
  animClassFade: string = 'enterFade';
  smallHeader: string = `smallHeader ${this.animClassTop}`;
  bigHeader: string = `bigHeader ${this.animClassTop}`;
  overLapped: boolean;
  isActiveList: any;
  private appSettingsSubscription: Subscription;
  constructor(
    private events: Events,
    private navCtrl: NavController,
    private toastCtrl: ToastController,
    private loadingCtrl: LoadingController,
    private translate: TranslateService,
    private configService: ConfigService,
    private authService: AuthService,
    private apiService: ApiService,
    private routerStateTrackerService: RouterStateTrackerService,
    private ngZone: NgZone,
    private cdRef: ChangeDetectorRef,
    private themeService: ThemeService,
    private preference: PreferencesService,
    private modalCtrl: ModalController,
  ) {}
  async ionViewWillEnter() {}

  async ngAfterViewInit() {
    this.themeService.updateHeaderSize('smallHead');
    this.routerStateTrackerService.registerActivePage(this);
    this.appSettingsSubscription = this.configService.appSettings$.subscribe((currentSettings) => {
      this.settings = currentSettings;
      this.translate.setDefaultLang(this.settings.appLanguage);
      this.translate.use(this.settings.appLanguage);
    });
    this.customer = await this.authService.getAuthUser();
    this.apiGetConsultants();
  }
  updateIt() {
    // this.preference.updatePreferences();
  }
  public async playPreExitAnimation(): Promise<void> {
    console.group('NotificationsPage: `playPreExitAnimation` called by RouterStateTrackerService.');

    this.isActiveList = '';
    this.animClassTop = 'exitTop';
    this.smallHeader = `smallHeader ${this.animClassTop}`;
    this.bigHeader = `bigHeader ${this.animClassTop}`;
    this.animClassBottom = 'exitBottom';
    this.animClassFade = 'exitFade';
    this.animClassAppear = 'exitAppear';
    this.themeService.updateHeaderSize('smallHead');

    try {
      await new Promise((resolve) => setTimeout(resolve, 500)); // Your desired 0.6s delay
    } catch (error) {
      return Promise.resolve();
    }
  }
  ngOnDestroy() {
    this.routerStateTrackerService.unregisterActivePage(this);
  }
  apiGetConsultants = () => {
    this.pastConsultation = [];
    this.scheduledConsultation = [];
    this.apiService
      .get(endpoints.consultations + '?customer_id=' + this.customer.id)
      .pipe(first())
      .subscribe(
        (response) => {
          this.loader = false;
          if (response.success) {
            this.consultantsList = response.data.consultations;
            this.consultantsList.map((consultant) => {
              //   if (moment(this.today).isAfter(moment(consultant.date))) {
              //     this.pastConsultation.push(consultant);
              //   } else {
              this.scheduledConsultation.push(consultant);
              //   }
            });
          } else if (response.code == 401) {
            this.events.publish('user:login', { user: null, time: new Date() });
          }
        },
        (err) => {
          this.loader = false;
        },
      );
  };
  closeModal = () => {
    this.modalCtrl.dismiss();
  };
  handleReorder(ev: CustomEvent<ItemReorderEventDetail>) {
    const itemToMove = this.scheduledConsultation.splice(ev.detail.from, 1)[0];

    // Adjust the 'to' index if it's out of bounds.
    // This is a common bug fix for reordering to the end of a list.
    let newIndex = ev.detail.to;
    if (newIndex >= this.scheduledConsultation.length) {
      newIndex = this.scheduledConsultation.length;
    }

    this.scheduledConsultation.splice(newIndex, 0, itemToMove);

    // You must call complete() to finish the reorder operation
    ev.detail.complete();
  }
  showLoading = async () => {
    this.loadingCtrl
      .create({
        message: this.translate.instant('please_wait'),
        cssClass: 'loader_class',
      })
      .then((a) => {
        a.present().then(() => {});
      });
  };
  hideLoading = async () => {
    setTimeout(async () => {
      try {
        this.loadingCtrl.dismiss();
      } catch (error) {}
    }, 1000);
  };
  toastMessage = async (msg) => {
    await this.toastCtrl
      .create({
        message: this.translate.instant(msg),
        duration: 4000,
        position: 'top',
        color: 'dark',
      })
      .then((toastElem) => toastElem.present());
  };
  isScroll(event: any) {
    const element = document.getElementById('stickyElement');
    if (element) {
      const ttop = element.getBoundingClientRect();

      const isstuck = ttop.top <= -80;
      this.ngZone.run(() => {
        this.overLapped = isstuck;
        if (isstuck == true) {
          this.themeService.updateHeaderSize('smallHead');
        } else {
          this.themeService.updateHeaderSize('bigHead');
        }
      });
    } else {
      console.warn('Element not found.');
    }
  }
  navigateToPage(page: string, data: any = { test: 'from community' }): void {
    const main = this.routerStateTrackerService.combinedData;

    this.routerStateTrackerService.navigateWithPreExitAnimation(page, data);
    // this.router.navigate([page], navigationExtras);
  }
}
